import { setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./NumberedList.module.less";

export type NumberedListProps = {
	trackingId: string;
};

export const NumberedList = (props: PropsWithChildren<NumberedListProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	return (
		<ol
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{children}
		</ol>
	);
};
NumberedList.displayName = "NumberedList";

const NumberedListItem = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<li>{children}</li>
	);
};
NumberedListItem.displayName = "NumberedList.Item";

NumberedList.Item = NumberedListItem;
